"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingBar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_components_2 = require("styled-components");
const rotate = (0, styled_components_2.keyframes) `
    from {
        background-position-x: 0px;
    }
    to {
      background-position-x: 1000px;
    }
`;
exports.LoadingBar = styled_components_1.default.div `
  height: 15px;
  background: repeating-linear-gradient(
    120deg,
    #fff,
    #fff 10px,
    #fff 10px,
    rgb(166, 208, 228) 25px
  );

  animation: ${rotate} 20s linear infinite;

  border: 1px solid rgb(112, 131, 148);
  border-radius: 3px;
`;
//# sourceMappingURL=loading-bar.js.map